<script setup>
import { useNuxtApp } from '#app'

const model = defineModel()
const { $_ } = useNuxtApp()
</script>
<template>
  <button
    class="bg-green text-white transition hover:bg-white hover:text-green hover:ring-2 hover:ring-green focus:outline-none text-sm font-bold uppercase rounded-bl-2xl rounded-br-[4px] rounded-tl-[4px] rounded-tr-2xl px-5 py-[14px]"
    @click="() => (model = false)">
    {{ $_('components/popup_close.text', 'Zavřít') }}
  </button>
</template>
<style scoped>
button {
  display: block;
  margin: 0 auto;
}
</style>
